import React, { Component, PureComponent, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import DataSheet from 'wix-react-datasheet/lib';
import classNames from 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import { Node_Type, ToolbarType } from 'wix-rich-content-common';
import { cloneDeep, debounce } from 'lodash';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import { RicosNodeContextProvider, RicosNodeContext } from 'ricos-context';

var __defProp$f = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
const DragAndDropIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$b({ xmlns: "http://www.w3.org/2000/svg", width: "9px", height: "13px", viewBox: "0 0 9 13" }, props), /* @__PURE__ */ React.createElement("g", { id: "Symbols", stroke: "none" }, /* @__PURE__ */ React.createElement(
  "g",
  {
    id: "drag&drop/row/unselected",
    transform: "translate(-9.000000, -15.000000)",
    fill: "currentColor"
  },
  /* @__PURE__ */ React.createElement(
    "g",
    {
      transform: "translate(14.000000, 21.500000) rotate(-270.000000) translate(-14.000000, -21.500000) translate(-7.000000, 8.000000)",
      id: "drag&drop/column"
    },
    /* @__PURE__ */ React.createElement("g", { id: "Group-5", transform: "translate(15.000000, 10.000000)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M2,4.8 C2.62132034,4.8 3.13235254,5.26813868 3.19380454,5.87654553 L3.2,6 C3.2,6.62132034 2.73186132,7.13235254 2.12345447,7.19380454 L2,7.2 C1.3372583,7.2 0.8,6.66736221 0.8,6 C0.8,5.37867966 1.26813868,4.86764746 1.87654553,4.80619546 L2,4.8 Z M6,4.8 C6.62132034,4.8 7.13235254,5.26813868 7.19380454,5.87654553 L7.2,6 C7.2,6.62132034 6.73186132,7.13235254 6.12345447,7.19380454 L6,7.2 C5.3372583,7.2 4.8,6.66736221 4.8,6 C4.8,5.37867966 5.26813868,4.86764746 5.87654553,4.80619546 L6,4.8 Z M10,4.8 C10.6213203,4.8 11.1323525,5.26813868 11.1938045,5.87654553 L11.2,6 C11.2,6.62132034 10.7318613,7.13235254 10.1234545,7.19380454 L10,7.2 C9.3372583,7.2 8.8,6.66736221 8.8,6 C8.8,5.37867966 9.26813868,4.86764746 9.87654553,4.80619546 L10,4.8 Z",
        id: "Color"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M2,0.2 C2.62132034,0.2 3.13235254,0.66813868 3.19380454,1.27654553 L3.2,1.4 C3.2,2.02132034 2.73186132,2.53235254 2.12345447,2.59380454 L2,2.6 C1.3372583,2.6 0.8,2.06736221 0.8,1.4 C0.8,0.778679656 1.26813868,0.267647457 1.87654553,0.206195465 L2,0.2 Z M6,0.2 C6.62132034,0.2 7.13235254,0.66813868 7.19380454,1.27654553 L7.2,1.4 C7.2,2.02132034 6.73186132,2.53235254 6.12345447,2.59380454 L6,2.6 C5.3372583,2.6 4.8,2.06736221 4.8,1.4 C4.8,0.778679656 5.26813868,0.267647457 5.87654553,0.206195465 L6,0.2 Z M10,0.2 C10.6213203,0.2 11.1323525,0.66813868 11.1938045,1.27654553 L11.2,1.4 C11.2,2.02132034 10.7318613,2.53235254 10.1234545,2.59380454 L10,2.6 C9.3372583,2.6 8.8,2.06736221 8.8,1.4 C8.8,0.778679656 9.26813868,0.267647457 9.87654553,0.206195465 L10,0.2 Z",
        id: "Color"
      }
    ))
  )
)));

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
const SelectTableIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8px",
    height: "9px",
    viewBox: "0 0 8 9",
    version: "1.1"
  }, props),
  /* @__PURE__ */ React.createElement("g", { id: "Symbols", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "g",
    {
      id: "select-all-table-/-default",
      transform: "translate(-6.000000, -6.000000)",
      fill: "currentColor"
    },
    /* @__PURE__ */ React.createElement("g", { id: "Group-3", transform: "translate(6.000000, 6.000000)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M6.44395231,8.49973295 C5.62343982,8.4690612 4.98007615,7.78418875 5.00047181,6.96312144 C5.02086747,6.14205413 5.69744127,5.48998831 6.51846407,5.5001164 C7.33948687,5.51024449 7.99977887,6.17880182 7.99992574,7.00012255 C7.98417426,7.84399206 7.28758242,8.5153508 6.44395231,8.49973295 L6.44395231,8.49973295 Z",
        id: "more_copy-path"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M6.44395231,2.99973295 C5.62343982,2.9690612 4.98007615,2.28418875 5.00047181,1.46312144 C5.02086747,0.642054133 5.69744127,-0.0100116918 6.51846407,0.000116401546 C7.33948687,0.0102444949 7.99977887,0.678801825 7.99992574,1.50012255 C7.98417426,2.34399206 7.28758242,3.0153508 6.44395231,2.99973295 L6.44395231,2.99973295 Z",
        id: "more_copy-path"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M1.44395231,8.49973295 C0.623439823,8.4690612 -0.0199238537,7.78418875 0.000471810597,6.96312144 C0.0208674749,6.14205413 0.697441271,5.48998831 1.51846407,5.5001164 C2.33948687,5.51024449 2.99977887,6.17880182 2.99992574,7.00012255 C2.98417426,7.84399206 2.28758242,8.5153508 1.44395231,8.49973295 L1.44395231,8.49973295 Z",
        id: "more_copy-path"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M1.44395231,2.99973295 C0.623439823,2.9690612 -0.0199238537,2.28418875 0.000471810597,1.46312144 C0.0208674749,0.642054133 0.697441271,-0.0100116918 1.51846407,0.000116401546 C2.33948687,0.0102444949 2.99977887,0.678801825 2.99992574,1.50012255 C2.98417426,2.34399206 2.28758242,3.0153508 1.44395231,2.99973295 L1.44395231,2.99973295 Z",
        id: "more_copy-path"
      }
    ))
  ))
);

var __defProp$d = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
const commonDesktopModalStyles = {
  width: "362px",
  boxSizing: "border-box",
  height: "max-content",
  minHeight: "209px",
  overflow: "visible",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  display: "block",
  position: "absolute",
  zIndex: 6,
  padding: "20px"
};
Object.freeze({
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    zIndex: 5
  },
  content: __spreadProps$4(__spreadValues$9({}, commonDesktopModalStyles), {
    borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
    boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
  })
});
const CELL_MANUAL_MIN_WIDTH = 65;
const CELL_AUTO_MIN_WIDTH = 120;
const ROW_DEFAULT_HEIGHT = 47;
({
  FORMATTING: `${Node_Type.TABLE}.formatting`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  BACKGROUND_COLOR: `${Node_Type.TABLE}.backgroundColor`,
  ROW_HEADER: `${Node_Type.TABLE}.rowHeader`,
  COLUMN_HEADER: `${Node_Type.TABLE}.columnHeader`,
  BORDER: `${Node_Type.TABLE}.border`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
});
({
  BORDER: `${Node_Type.TABLE}.border`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
});

({
  onClick: PropTypes.func.isRequired,
  dataHook: PropTypes.string,
  shouldDisable: PropTypes.bool,
  t: PropTypes.func
});

var styles$7 = {"cell":"-yfd8","header":"nbKRB","selected":"ebVQe","editing":"m7Ep4","singleSelection":"FJhh3","hideLastBlock":"JQaEp","editorWrapper":"Ci50y","viewerWrapper":"bLarR","hideFirstBlock":"K63we","editor":"fMrCg","edit":"h-abp","view":"p9bIe","editingToolbarWrapper":"yBx3v","selectAll":"CUUyu","disableSelection":"Xg7Y3"};

const theme = ({ colors, utils }) => {
  const { textColor, bgColor, actionColor } = colors;
  utils.toCssRgbA(actionColor || "", 0.06);
};
const DEFAULTS = Object.freeze({});

var __defProp$c = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __publicField$7 = (obj, key, value) => {
  __defNormalProp$c(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const getStyleVal = (elm, css) => {
  return window.getComputedStyle(elm, null).getPropertyValue(css);
};
const paddingDiff = (col) => {
  if (getStyleVal(col, "box-sizing") === "border-box") {
    return 0;
  }
  const padLeft = getStyleVal(col, "padding-left");
  const padRight = getStyleVal(col, "padding-right");
  return parseInt(padLeft) + parseInt(padRight);
};
const getRefWidthAsNumber = (ref) => getSizeStringAsNumber(ref.style.width);
const getSizeStringAsNumber = (str) => parseInt(str.substring(0, str.length - 2));
const range = (start, end) => {
  const array = [];
  const inc = end - start > 0;
  for (let i = start; inc ? i <= end : i >= end; inc ? i++ : i--) {
    inc ? array.push(i) : array.unshift(i);
  }
  return array;
};
const getRange = ({ start, end }) => {
  const ranges = [];
  start && end && range(start.i, end.i).map((i) => range(start.j, end.j).map((j) => ranges.push({ i, j })));
  return ranges;
};
const normalizeCellDimensions = (componentData) => {
  var _a, _b, _c, _d;
  componentData.config.rowsHeight = (_b = (_a = componentData.config) == null ? void 0 : _a.rowsHeight) == null ? void 0 : _b.map((height) => height != null ? height : 47);
  componentData.config.colsWidth = (_d = (_c = componentData.config) == null ? void 0 : _c.colsWidth) == null ? void 0 : _d.map((height) => height != null ? height : 100);
};
class TableDataUtil {
  constructor(componentData) {
    __publicField$7(this, "updateComponentData", (componentData) => {
      normalizeCellDimensions(componentData);
      this.componentData = componentData;
    });
    //TABLE DATA GETTERS
    __publicField$7(this, "getRowColumns", (i) => {
      var _a;
      return (_a = this.getRow(i)) == null ? void 0 : _a.columns;
    });
    __publicField$7(this, "getRows", () => {
      var _a, _b;
      return (_b = (_a = this.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.rows;
    });
    __publicField$7(this, "getRow", (i) => {
      var _a;
      return (_a = this.getRows()) == null ? void 0 : _a[i];
    });
    __publicField$7(this, "getRowNum", () => Object.entries(this.getRows() || {}).length);
    __publicField$7(this, "getColNum", () => Object.entries(this.getRowColumns(0) || {}).length);
    __publicField$7(this, "getCell", (i, j) => {
      var _a, _b;
      return this.getRow(i) && ((_b = (_a = this.getRowColumns(i)) == null ? void 0 : _a[j]) != null ? _b : {});
    });
    __publicField$7(this, "getCellContent", (i, j) => {
      var _a;
      return (_a = this.getCell(i, j)) == null ? void 0 : _a.content;
    });
    __publicField$7(this, "getCellStyle", (i, j) => {
      var _a;
      return (_a = this.getCell(i, j)) == null ? void 0 : _a.style;
    });
    __publicField$7(this, "getColsWidth", () => this.componentData.config.colsWidth);
    __publicField$7(this, "getRowsHeight", () => this.componentData.config.rowsHeight);
    __publicField$7(this, "getColWidth", (j) => this.getColsWidth()[j]);
    __publicField$7(this, "getRowHeight", (i) => this.getRowsHeight()[i]);
    __publicField$7(this, "getColsMinWidth", () => this.componentData.config.colsMinWidth);
    // get min width of column (in case we want min width for column with specific atomic plugins)
    __publicField$7(this, "getColMinWidth", (j) => {
      let colMinWidth = CELL_MANUAL_MIN_WIDTH;
      const numberOfRows = this.getRowNum();
      for (let i = 0; i < numberOfRows; i++) {
        const content = this.getCellContent(i, j);
        const contentState = content.getCurrentContent();
        contentState.getBlockMap().forEach((block) => {
          if (block.type === "atomic") {
            const entityKey = block.getEntityAt(0);
            const entity = entityKey ? contentState.getEntity(entityKey) : void 0;
            const type = entity == null ? void 0 : entity.getType();
            if (type === "wix-draft-plugin-image" || type === "wix-draft-plugin-video") {
              colMinWidth = 300;
            }
          }
        });
      }
      return colMinWidth;
    });
    __publicField$7(this, "getCellWidthAsPixel", (tableWidth, i, colsMinWidth = []) => {
      const colsWidthSum = this.getColsWidth().reduce((acc, val) => acc + val, 0);
      let smallestCellIndex, smallestCellWidth, currCellWidth;
      this.getColsWidth().forEach((width, index) => {
        const cellWidth = tableWidth * (width / colsWidthSum);
        if (index === i) {
          currCellWidth = cellWidth;
        } else if (cellWidth < CELL_AUTO_MIN_WIDTH && (!smallestCellWidth || smallestCellWidth > cellWidth)) {
          smallestCellWidth = Math.max(colsMinWidth[index], cellWidth);
          smallestCellIndex = index;
        }
      });
      if (smallestCellWidth) {
        currCellWidth = Math.min(CELL_AUTO_MIN_WIDTH, smallestCellWidth) * (this.getColWidth(i) / this.getColWidth(smallestCellIndex));
      }
      return Math.max(currCellWidth, colsMinWidth[i]);
    });
    __publicField$7(this, "getCellWidthAsRatio", (tableWidth, totalColsWidth, cellWidth) => parseInt(totalColsWidth * cellWidth / tableWidth, 10));
    //MERGE
    __publicField$7(this, "getCellMergeData", (i, j) => {
      var _a;
      return (_a = this.getCell(i, j)) == null ? void 0 : _a.merge;
    });
    __publicField$7(this, "getParentCell", (key) => {
      let parentCell;
      Object.entries(this.getRows()).forEach(([i, row]) => {
        !parentCell && Object.entries(row.columns).forEach(([j]) => {
          const merge = this.getCellMergeData(i, j);
          if ((merge == null ? void 0 : merge.key) === key) {
            parentCell = __spreadProps$3(__spreadValues$8({}, merge), { row: i, col: j });
          }
        });
      });
      return parentCell;
    });
    __publicField$7(this, "fixSelectedWithMergeCells", (selected) => {
      const selectedCells = getRange(selected);
      selectedCells.length > 1 && selectedCells.forEach(({ i, j }) => {
        const { parentCellKey, rowSpan, colSpan } = this.getCellMergeData(i, j) || {};
        const parentCell = parentCellKey && this.getParentCell(parentCellKey);
        const extendSelectionBySpan = (i2, j2, rowSpan2, colSpan2) => {
          if (rowSpan2 > 1 || colSpan2 > 1) {
            [...Array(rowSpan2).fill(0)].forEach((row, rowIndex) => {
              [...Array(colSpan2).fill(0)].forEach((col, colIndex) => {
                const fixPos = (key, newPos) => {
                  const start = selected.start[key] <= selected.end[key] ? selected.start : selected.end;
                  const end = selected.start[key] <= selected.end[key] ? selected.end : selected.start;
                  start[key] > newPos && (start[key] = newPos);
                  end[key] < newPos && (end[key] = newPos);
                };
                fixPos("i", i2 + rowIndex);
                fixPos("j", j2 + colIndex);
              });
            });
          }
        };
        if (parentCell) {
          const { row, col, rowSpan: rowSpan2, colSpan: colSpan2 } = parentCell;
          extendSelectionBySpan(parseInt(row), parseInt(col), rowSpan2, colSpan2);
        } else {
          extendSelectionBySpan(i, j, rowSpan, colSpan);
        }
      });
      return selected;
    });
    __publicField$7(this, "getCellParentPosition", (i, j) => {
      const { parentCellKey, rowSpan, colSpan } = this.getCellMergeData(i, j) || {};
      if (parentCellKey) {
        const { row, col } = this.getParentCell(parentCellKey);
        return { i: row, j: col };
      } else if (rowSpan > 1 || colSpan > 1) {
        return { i, j };
      }
    });
    __publicField$7(this, "getRowCellsParentPosition", (i) => {
      let parentPos;
      Object.entries(this.getRowColumns(i)).forEach(([j]) => {
        !parentPos && (parentPos = this.getCellParentPosition(i, j));
      });
      return parentPos;
    });
    __publicField$7(this, "getColCellsParentPosition", (j) => {
      let parentPos;
      Object.entries(this.getRows()).forEach(([i]) => {
        !parentPos && (parentPos = this.getCellParentPosition(i, j));
      });
      return parentPos;
    });
    //SELECTION
    __publicField$7(this, "getRowsSelection", (rowsIndexes) => ({
      start: { i: rowsIndexes.start, j: 0 },
      end: { i: rowsIndexes.end, j: this.getColNum() - 1 }
    }));
    __publicField$7(this, "getColsSelection", (colsIndexes) => ({
      start: { i: 0, j: colsIndexes.start },
      end: { i: this.getRowNum() - 1, j: colsIndexes.end }
    }));
    __publicField$7(this, "getAllCellsSelection", () => ({
      start: { i: 0, j: 0 },
      end: {
        i: this.getRowNum() - 1,
        j: this.getColNum() - 1
      }
    }));
    __publicField$7(this, "isAllCellsSelected", (start, end) => start && end && Math.min(start.i, end.i) === 0 && Math.min(start.j, end.j) === 0 && Math.max(start.i, end.i) === this.getRowNum() - 1 && Math.max(start.j, end.j) === this.getColNum() - 1);
    __publicField$7(this, "getSelectionStyle", (selection, defaultBG, defaultBorder) => {
      var _a, _b;
      const range2 = getRange(selection);
      let selectionBGColor = ((_a = this.getCellStyle(range2[0].i, range2[0].j)) == null ? void 0 : _a.backgroundColor) || defaultBG;
      let selectionBorderColor = this.getConsistentCellBorderColor(
        selection,
        range2[0].i,
        range2[0].j,
        defaultBorder
      );
      let selectionVerticalAlign = ((_b = this.getCellStyle(range2[0].i, range2[0].j)) == null ? void 0 : _b.verticalAlign) || "top";
      let selectionBorderIsActive = false;
      range2.forEach(({ i, j }) => {
        var _a2, _b2;
        const currentCellBGColor = ((_a2 = this.getCellStyle(i, j)) == null ? void 0 : _a2.backgroundColor) || defaultBG;
        if (selectionBGColor !== currentCellBGColor) {
          selectionBGColor = false;
        }
        const currentCellBorderColor = this.getConsistentCellBorderColor(
          selection,
          i,
          j,
          selectionBorderColor
        );
        if (selectionBorderColor !== currentCellBorderColor) {
          selectionBorderColor = false;
        }
        if (this.isCellBorderActive(selection, i, j)) {
          selectionBorderIsActive = true;
        }
        const currentVerticalAlign = ((_b2 = this.getCellStyle(i, j)) == null ? void 0 : _b2.verticalAlign) || "top";
        if (selectionVerticalAlign !== currentVerticalAlign) {
          selectionVerticalAlign = false;
        }
      });
      return {
        selectionBGColor,
        selectionBorderColor,
        selectionVerticalAlign,
        selectionBorderIsActive
      };
    });
    __publicField$7(this, "getSelectedRows", (range2 = []) => {
      const colNum = this.getColNum();
      return this.getSelectedSection(range2, ({ i, j }) => ({ key: i, value: j }), colNum);
    });
    __publicField$7(this, "getSelectedCols", (range2 = []) => {
      const rowNum = this.getRowNum();
      return this.getSelectedSection(range2, ({ i, j }) => ({ key: j, value: i }), rowNum);
    });
    __publicField$7(this, "getSelectedSection", (range2, keyValueMapper, cellsNum) => {
      const selectedCells = {};
      range2 == null ? void 0 : range2.forEach((range3) => {
        const { key, value } = keyValueMapper(range3);
        if (selectedCells[key]) {
          selectedCells[key].push(value);
        } else {
          selectedCells[key] = [value];
        }
      });
      const selected = [];
      Object.entries(selectedCells).forEach(
        ([j, col]) => col.length === cellsNum && selected.push(j)
      );
      return selected[0] && selected;
    });
    __publicField$7(this, "getCellBorderColor", (selection, row, col) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      const style = {};
      const range2 = getRange(selection);
      if (!range2.find(({ i, j }) => i === row && j === col - 1)) {
        style.borderLeft = (_b = (_a = this.getCell(row, col)) == null ? void 0 : _a.border) == null ? void 0 : _b.left;
      }
      if (!range2.find(({ i, j }) => i === row && j === col + 1)) {
        style.borderRight = (_d = (_c = this.getCell(row, col)) == null ? void 0 : _c.border) == null ? void 0 : _d.right;
      }
      if (!range2.find(({ i, j }) => i === row - 1 && j === col)) {
        style.borderTop = (_f = (_e = this.getCell(row, col)) == null ? void 0 : _e.border) == null ? void 0 : _f.top;
      }
      if (!range2.find(({ i, j }) => i === row + 1 && j === col)) {
        style.borderBottom = (_h = (_g = this.getCell(row, col)) == null ? void 0 : _g.border) == null ? void 0 : _h.bottom;
      }
      return Object.values(style);
    });
    __publicField$7(this, "getConsistentCellBorderColor", (selection, row, col, defaultBorder) => {
      const borderStyles = this.getCellBorderColor(selection, row, col);
      const isBorderConsistent = borderStyles.every((borderStyle) => borderStyle === borderStyles[0]);
      if (isBorderConsistent) {
        const borderColor = borderStyles[0] ? this.getColorFromBorderStyle(borderStyles[0]) : defaultBorder;
        return borderColor;
      } else {
        return false;
      }
    });
    __publicField$7(this, "isCellBorderActive", (selection, row, col) => {
      const borderStyles = this.getCellBorderColor(selection, row, col);
      return borderStyles.some((borderStyle) => borderStyle !== void 0);
    });
    __publicField$7(this, "getColorFromBorderStyle", (borderStyle) => {
      return borderStyle.includes("transparent") ? "transparent" : `#${borderStyle.split("#")[1]}`;
    });
    __publicField$7(this, "getCellBorders", (selection, row, col, color) => {
      const range2 = getRange(selection);
      const { rowSpan = 1, colSpan = 1 } = this.getCellMergeData(row, col) || {};
      const borderColor = color || "var(--ricos-settings-action-color, var(--ricos-action-color, #0261ff))";
      const borders = {};
      if (!range2.find(({ i, j }) => i === row && j === col - 1)) {
        borders.left = borderColor;
      }
      if (!range2.find(({ i, j }) => i === row && j === col + colSpan)) {
        borders.right = borderColor;
      }
      if (!range2.find(({ i, j }) => i === row - 1 && j === col)) {
        borders.top = borderColor;
      }
      if (!range2.find(({ i, j }) => i === row + rowSpan && j === col)) {
        borders.bottom = borderColor;
      }
      return borders;
    });
    __publicField$7(this, "getRowHeader", () => this.componentData.config.rowHeader);
    __publicField$7(this, "getColHeader", () => this.componentData.config.colHeader);
    __publicField$7(this, "isCellContainedInHeader", (i, j) => i === 0 && this.getRowHeader() || j === 0 && this.getColHeader());
    this.updateComponentData(componentData);
  }
}

var styles$6 = {"borderT":"LSly5","borderB":"Lkg--","borderL":"drvuN","borderR":"e-9Xc"};

const CellBorders = ({ borders }) => [
  (borders == null ? void 0 : borders.top) && /* @__PURE__ */ React.createElement("div", { key: "top", style: { background: borders.top }, className: styles$6.borderT }),
  (borders == null ? void 0 : borders.bottom) && /* @__PURE__ */ React.createElement("div", { key: "bottom", style: { background: borders.bottom }, className: styles$6.borderB }),
  (borders == null ? void 0 : borders.right) && /* @__PURE__ */ React.createElement("div", { key: "right", style: { background: borders.right }, className: styles$6.borderR }),
  (borders == null ? void 0 : borders.left) && /* @__PURE__ */ React.createElement("div", { key: "left", style: { background: borders.left }, className: styles$6.borderL })
];
CellBorders.propTypes = {
  borders: PropTypes.object
};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __publicField$6 = (obj, key, value) => {
  __defNormalProp$b(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const tableKeysToIgnoreOnEdit = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"];
class Cell extends Component {
  constructor() {
    super(...arguments);
    __publicField$6(this, "selectCellContent", () => {
      const { row, col, selectCellContent, isMobile } = this.props;
      !isMobile && (selectCellContent == null ? void 0 : selectCellContent(row, col));
    });
    __publicField$6(this, "isSingleCellSelected", (selectedCells = {}) => {
      var _a, _b, _c, _d;
      return ((_a = selectedCells == null ? void 0 : selectedCells.start) == null ? void 0 : _a.i) === ((_b = selectedCells == null ? void 0 : selectedCells.end) == null ? void 0 : _b.i) && ((_c = selectedCells == null ? void 0 : selectedCells.start) == null ? void 0 : _c.j) === ((_d = selectedCells == null ? void 0 : selectedCells.end) == null ? void 0 : _d.j);
    });
    __publicField$6(this, "isEditing", (editing, selectedCells) => editing && this.isSingleCellSelected(selectedCells));
    __publicField$6(this, "setEditorRef", (ref) => {
      const { setEditorRef, row, col } = this.props;
      this.editorRef = ref;
      setEditorRef && setEditorRef(ref, row, col);
    });
    __publicField$6(this, "setTdRef", (ref) => this.tdRef = ref);
    __publicField$6(this, "getToolbarPosition", () => {
      if (this.tdRef) {
        const cellOffsetLeft = this.tdRef.offsetLeft;
        const tableWidth = this.props.tableWidth;
        return {
          x: 0,
          containerWidth: tableWidth,
          offsetLeftInsideContainer: cellOffsetLeft
        };
      }
    });
    __publicField$6(this, "onKeydown", (e) => {
      const { editing, onKeyDown, isMobile } = this.props;
      if (editing && !isMobile) {
        if (e.key === "Backspace") {
          e.stopPropagation();
        } else if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
          e.stopPropagation();
        }
        const shouldCreateNewLine = e.key === "Enter" && (e.altKey || e.shiftKey || e.metaKey);
        if (!tableKeysToIgnoreOnEdit.includes(e.key) && !shouldCreateNewLine) {
          onKeyDown(e);
        }
      } else if (!editing && tableKeysToIgnoreOnEdit.includes(e.key)) {
        onKeyDown(e);
        e.stopPropagation();
        e.preventDefault();
      }
    });
    __publicField$6(this, "fixReactModalButtons", (toolbarButtons) => {
      Object.values(toolbarButtons).forEach((buttonsProps) => {
        if (buttonsProps.type === "DROPDOWN") {
          buttonsProps.type = "modal";
        }
      });
    });
    __publicField$6(this, "getEditorWrapperStyle", (additionalStyles, isEditing) => {
      const shouldSetEditStyle = !this.props.isMobile && isEditing;
      const style = shouldSetEditStyle ? __spreadValues$7({ minHeight: this.tdHeight }, additionalStyles) : {};
      const { verticalAlign } = additionalStyles;
      if (shouldSetEditStyle && verticalAlign) {
        style.display = "flex";
        if (verticalAlign === "middle") {
          style.alignItems = "center";
        } else if (verticalAlign === "bottom") {
          style.alignItems = "flex-end";
        }
      }
      return style;
    });
    __publicField$6(this, "getCellBorders", (cellBorders, shouldShowSelectedStyle) => {
      const { table, selectedCells, row, col, disableSelectedStyle, isMobile, selected } = this.props;
      const cellSelectionBorders = table.getCellBorders(selectedCells, row, col);
      let borders = {};
      if (disableSelectedStyle && selected) {
        Object.entries(cellBorders).forEach(([key, val]) => {
          !cellSelectionBorders[key] && (borders[key] = val);
        });
      } else {
        borders = cellBorders;
      }
      return !isMobile && shouldShowSelectedStyle ? __spreadValues$7(__spreadValues$7({}, borders), cellSelectionBorders) : borders;
    });
    __publicField$6(this, "hideBlocks", () => {
      const { row, col, table, setEditorRef } = this.props;
      const editorState = table.getCellContent(row, col);
      if (!editorState) {
        return {};
      }
      const blocks = setEditorRef ? editorState.getCurrentContent().getBlocksAsArray() : editorState.blocks;
      if (blocks.length >= 3) {
        let lastBlockText;
        let firstBlockText;
        if (setEditorRef) {
          const currentContent = editorState.getCurrentContent();
          lastBlockText = currentContent.getLastBlock().getText();
          firstBlockText = currentContent.getFirstBlock().getText();
        } else {
          lastBlockText = blocks[blocks.length - 1].text;
          firstBlockText = blocks[0].text;
        }
        const hideFirstBlock = firstBlockText === "" || firstBlockText === "\u200B";
        const hideLastBlock = lastBlockText === "" || lastBlockText === "\u200B";
        return { hideFirstBlock, hideLastBlock };
      } else {
        return {};
      }
    });
    __publicField$6(this, "onCellClick", () => this.props.isMobile && this.props.onDoubleClick());
  }
  componentDidUpdate(prevProps) {
    var _a, _b;
    const isCellWasEditing = this.isEditing(prevProps.editing, prevProps.selectedCells);
    const isCellEditing = this.isEditing(this.props.editing, this.props.selectedCells);
    const isGoIntoEdit = !isCellWasEditing && isCellEditing;
    const isGoOutFromEdit = isCellWasEditing && !isCellEditing;
    const { selectedCells, isMobile, setEditingActive, toolbarRef } = this.props;
    if (isGoIntoEdit) {
      this.editorRef.focus();
      setEditingActive(true);
      this.selectCellContent();
    } else if (isGoOutFromEdit) {
      setEditingActive(false);
      toolbarRef == null ? void 0 : toolbarRef.setEditingTextFormattingToolbarProps(false);
      this.selectCellContent();
    }
    if (this.props.selected && !prevProps.selected && !isCellEditing && !isMobile) {
      this.selectCellContent();
      selectedCells && getRange(selectedCells).length === 1 && ((_a = this.editorRef) == null ? void 0 : _a.focus());
      this.tdHeight = ((_b = this.tdRef) == null ? void 0 : _b.offsetHeight) - 1;
    }
  }
  render() {
    var _a, _b, _c, _d, _e;
    const {
      row,
      col,
      style,
      onMouseDown,
      onMouseOver,
      onDoubleClick,
      editing,
      onContextMenu,
      children,
      selected,
      selectedCells,
      table,
      isMobile,
      disableSelectedStyle,
      setEditorRef,
      selectCellContent
    } = this.props;
    const { style: additionalStyles = {}, merge = {}, border = {} } = table.getCell(row, col) || {};
    const { colSpan = 1, rowSpan = 1, parentCellKey } = merge;
    const isEditing = this.isEditing(editing, selectedCells);
    const shouldShowSelectedStyle = selected && !disableSelectedStyle && !isEditing;
    const range = selectedCells && getRange(selectedCells);
    const cellBorders = this.getCellBorders(border, shouldShowSelectedStyle);
    const isContainedInHeader = table.isCellContainedInHeader(row, col);
    const Tag = isContainedInHeader ? "th" : "td";
    const editorState = this.editorRef && isEditing && table.getCellContent(row, col);
    const Selection = editorState && editorState.getSelection();
    const cellContentContainText = editorState ? editorState.getCurrentContent().getBlockMap().filter((x) => x.getType() === "unstyled").some((x) => x.getText() !== "" && x.getText() !== "\u200B") : false;
    const showFormattingToolbar = this.editorRef && isEditing && (!Selection.isCollapsed() && Selection.getHasFocus() || document && document.querySelector('[data-id="rich-content-editor-modal"]')) && cellContentContainText;
    if (showFormattingToolbar) {
      const toolbarButtons = cloneDeep((_b = (_a = this.editorRef) == null ? void 0 : _a.getToolbarProps) == null ? void 0 : _b.call(_a, ToolbarType.FORMATTING));
      toolbarButtons && this.fixReactModalButtons(toolbarButtons);
      (_c = this.props.toolbarRef) == null ? void 0 : _c.setEditingTextFormattingToolbarProps(toolbarButtons);
    } else if (isEditing) {
      (_d = this.props.toolbarRef) == null ? void 0 : _d.setEditingTextFormattingToolbarProps(false);
    }
    const editorWrapperStyle = this.getEditorWrapperStyle(additionalStyles, isEditing);
    const { hideFirstBlock, hideLastBlock } = this.hideBlocks();
    return parentCellKey ? null : (
      //eslint-disable-next-line
      /* @__PURE__ */ React.createElement(
        Tag,
        {
          "data-hook": "table-plugin-cell",
          ref: this.setTdRef,
          className: classNames(
            styles$7.cell,
            isContainedInHeader && styles$7.header,
            shouldShowSelectedStyle && !isEditing && styles$7.selected
          ),
          onMouseDown,
          onMouseOver,
          onDoubleClick,
          onClick: this.onCellClick,
          onContextMenu,
          colSpan,
          rowSpan,
          style: __spreadValues$7(__spreadValues$7({}, style), additionalStyles),
          onKeyDown: this.onKeydown
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: classNames(
              setEditorRef ? styles$7.editorWrapper : styles$7.viewerWrapper,
              !isEditing && hideFirstBlock && styles$7.hideFirstBlock,
              !isEditing && hideLastBlock && styles$7.hideLastBlock,
              !isMobile && isEditing && styles$7.editing,
              !isEditing && styles$7.disableSelection
            ),
            style: editorWrapperStyle
          },
          /* @__PURE__ */ React.createElement(
            Editor,
            {
              editing: isMobile ? selected : isEditing,
              selected,
              contentState: table.getCellContent(row, col),
              setEditorRef: this.setEditorRef,
              isEditor: selectCellContent
            },
            children
          )
        ),
        /* @__PURE__ */ React.createElement(CellBorders, { borders: cellBorders }),
        /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              height: shouldShowSelectedStyle ? (_e = this.tdRef) == null ? void 0 : _e.offsetHeight : 0
            },
            className: classNames(
              shouldShowSelectedStyle && styles$7.selected,
              (range == null ? void 0 : range.length) === 1 && styles$7.singleSelection
            )
          }
        )
      )
    );
  }
}
class Editor extends Component {
  constructor() {
    super(...arguments);
    __publicField$6(this, "setEditorRef", (ref) => {
      this.editor = ref;
      this.props.setEditorRef(ref);
    });
  }
  shouldComponentUpdate(nextProps) {
    const { editing, selected, contentState } = this.props;
    const isContentStateChanged = contentState !== nextProps.contentState;
    return editing || nextProps.editing || selected || isContentStateChanged;
  }
  render() {
    const { children, editing, selected } = this.props;
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement("div", { className: classNames(styles$7.editor, editing ? styles$7.edit : styles$7.view) }, React.cloneElement(children, {
        ref: this.setEditorRef,
        editing,
        readOnly: !editing && !selected
      }))
    );
  }
}
Editor.propTypes = {
  setEditorRef: PropTypes.func,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  children: PropTypes.any,
  contentState: PropTypes.object,
  setIsHighlighted: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
};
Cell.propTypes = {
  t: PropTypes.func,
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  editing: PropTypes.bool,
  updated: PropTypes.bool,
  onMouseDown: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  style: PropTypes.object,
  children: PropTypes.any,
  setDragsVisibility: PropTypes.func,
  table: PropTypes.object,
  setEditorRef: PropTypes.func,
  toolbarRef: PropTypes.any,
  selectedCells: PropTypes.object,
  setEditingActive: PropTypes.func,
  tableWidth: PropTypes.number,
  isMobile: PropTypes.bool,
  disableSelectedStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onKeyDown: PropTypes.func,
  selectCellContent: PropTypes.func
};

var __defProp$a = Object.defineProperty;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$5 = (obj, key, value) => {
  __defNormalProp$a(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class RowRenderer extends Component {
  constructor() {
    super(...arguments);
    __publicField$5(this, "setRef", (ref) => {
      var _a, _b;
      return (_b = (_a = this.props).setRowRef) == null ? void 0 : _b.call(_a, ref, this.props.row);
    });
  }
  shouldComponentUpdate(nextProps) {
    var _a;
    return ((_a = nextProps.rowsToUpdate) == null ? void 0 : _a.includes(nextProps.row)) || false;
  }
  render() {
    const { row, children, getRowHeight } = this.props;
    const height = getRowHeight(row);
    return /* @__PURE__ */ React.createElement("tr", { style: { height }, ref: this.setRef }, children);
  }
}
RowRenderer.propTypes = {
  row: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  getRowHeight: PropTypes.func,
  setRowRef: PropTypes.func,
  rowsToUpdate: PropTypes.array
};

var styles$5 = {"viewMode":"x0rQE","editMode":"mSGCN","container":"okQLv","cell":"yloL2"};

var styles$4 = {"container":"ZFjH2","dragAndDrop":"w6VRC","active":"_3-9lE","selectAll":"o15Yc","dragging":"aDHIl","horizontal":"P6Rjn","selectPreview":"iRY2z","vertical":"T3UgD"};

var __defProp$9 = Object.defineProperty;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$4 = (obj, key, value) => {
  __defNormalProp$9(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class DragAndDropSection extends React.Component {
  constructor(props) {
    super(props);
    __publicField$4(this, "removeShiftKey", () => this.shiftKey = false);
    __publicField$4(this, "setShiftKey", (e) => e.key === "Shift" && (this.shiftKey = true));
    __publicField$4(this, "onDragMouseDown", (e, i) => {
      this.curDrag = e.target;
      this.startPoint = this.getEventDiff(e);
      if (this.isActive(i)) {
        this.clickedOnActiveDrag = true;
      } else {
        this.drags = {};
        if (this.shiftKey && this.props.activeDrag) {
          this.drags.start = Math.min(i, this.props.activeDrag[0]);
          this.drags.end = Math.max(i, this.props.activeDrag[this.props.activeDrag.length - 1]);
        } else {
          this.drags.start = i;
          this.drags.end = i;
        }
        this.props.onDragClick(this.drags);
      }
    });
    __publicField$4(this, "getEventDiff", (e) => this.props.horizontal ? e.pageX : e.pageY);
    __publicField$4(this, "onMouseMove", (e) => {
      const isDragging = this.curDrag && (this.isDragging || Math.abs(this.startPoint - this.getEventDiff(e)) > 25);
      if (isDragging) {
        const { activeDrag } = this.props;
        this.isDragging = true;
        this.drags = { start: Math.min(...activeDrag), end: Math.max(...activeDrag) };
        this.props.onDrag(e, this.drags);
      }
    });
    __publicField$4(this, "onMouseUp", (e) => {
      if (this.clickedOnActiveDrag) {
        this.props.onDragClick();
        this.clickedOnActiveDrag = false;
      }
      if (this.curDrag) {
        this.curDrag = void 0;
        if (this.isDragging) {
          this.isDragging = void 0;
          this.props.onDragEnd(e, this.drags);
          this.drags = null;
        }
      }
    });
    __publicField$4(this, "isActive", (i) => {
      var _a;
      return (_a = this.props.activeDrag) == null ? void 0 : _a.includes(i);
    });
    __publicField$4(this, "getSelectedPreviewStyle", () => {
      const { size, horizontal, index, selectAll } = this.props;
      const selectPreviewStyle = {
        visibility: this.isActive(index) && (selectAll ? horizontal : !selectAll) && "visible"
      };
      if (horizontal) {
        selectPreviewStyle.height = size ? size - 20 : 0;
        this.isActive(index + 1) && (selectPreviewStyle.borderRight = "none");
        this.isActive(index - 1) && (selectPreviewStyle.borderLeft = "none");
      } else {
        selectPreviewStyle.width = size;
        this.isActive(index + 1) && (selectPreviewStyle.borderBottom = "none");
        this.isActive(index - 1) && (selectPreviewStyle.borderTop = "none");
      }
      return selectPreviewStyle;
    });
    this.state = {};
  }
  componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("keydown", this.setShiftKey);
    document.addEventListener("keyup", this.removeShiftKey);
  }
  componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("keydown", this.setShiftKey);
    document.removeEventListener("keyup", this.removeShiftKey);
  }
  render() {
    const { horizontal, selectAll, index } = this.props;
    const isActive = this.isActive(index);
    const selectPreviewStyle = this.getSelectedPreviewStyle();
    return /* @__PURE__ */ React.createElement("div", { className: styles$4.container }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(
          styles$4.dragAndDrop,
          isActive && styles$4.active,
          selectAll && styles$4.selectAll,
          this.isDragging && styles$4.dragging
        ),
        onMouseDown: (e) => this.onDragMouseDown(e, index),
        "data-hook": `${horizontal ? "col" : "row"}Drag-${index}`
      },
      /* @__PURE__ */ React.createElement(
        DragAndDropIcon,
        {
          className: classNames(horizontal && styles$4.horizontal),
          style: {
            visibility: !selectAll && isActive && "visible",
            cursor: this.isDragging ? "grabbing" : "grab"
          }
        }
      )
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles$4.selectPreview, !horizontal && styles$4.vertical),
        style: selectPreviewStyle
      }
    ));
  }
}
DragAndDropSection.propTypes = {
  onDragClick: PropTypes.func.isRequired,
  horizontal: PropTypes.bool,
  selectAll: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  activeDrag: PropTypes.array,
  index: PropTypes.number,
  size: PropTypes.number
};

var styles$3 = {"resizer":"IKJcp","horizonResizer":"xNeL9","verticalResizer":"S1Pqt","highlightOnly":"SgBwn"};

var __defProp$8 = Object.defineProperty;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$3 = (obj, key, value) => {
  __defNormalProp$8(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const RESIZER_STYLE = "1px solid #0000ff";
class Resizer extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField$3(this, "getPosition", (e) => this.props.horizontal ? e.pageX : e.pageY);
    __publicField$3(this, "getSize", () => this.props.horizontal ? this.curTarget.offsetWidth : this.curTarget.offsetHeight);
    __publicField$3(this, "setNewSize", (ref, size) => this.props.horizontal ? ref.style.width = size : ref.style.height = size);
    __publicField$3(this, "setMinSize", (ref, size) => ref.style.minWidth = size);
    __publicField$3(this, "onMouseDown", (e) => {
      const { horizontal, size, onResizeStart, index, itemsRefs } = this.props;
      horizontal ? this.ref.style.height = `${size}px` : this.ref.style.width = `${size}px`;
      e.stopPropagation();
      this.curTarget = itemsRefs[index];
      this.siblingCell = horizontal && itemsRefs[index + 1];
      this.position = this.getPosition(e);
      const padding = paddingDiff(this.curTarget);
      this.curSize = horizontal ? getRefWidthAsNumber(this.curTarget) : this.getSize() - padding;
      this.siblingSize = this.siblingCell && getRefWidthAsNumber(this.siblingCell);
      onResizeStart();
    });
    __publicField$3(this, "onMouseMove", (e) => {
      if (this.curTarget) {
        const diff = this.getPosition(e) - this.position;
        const newSize = this.curSize + diff;
        const { minSize, setContainerSize, horizontal, overflowWidth } = this.props;
        if (newSize >= minSize) {
          horizontal && newSize < CELL_AUTO_MIN_WIDTH && this.setMinSize(this.curTarget, newSize + "px");
          this.setNewSize(this.curTarget, newSize + "px");
          setContainerSize && setContainerSize(newSize + "px", this.props.index);
          if (diff > 0 || diff <= 0 && overflowWidth <= 0) {
            const siblingNewSize = this.siblingSize - diff;
            siblingNewSize && siblingNewSize >= CELL_AUTO_MIN_WIDTH && this.setNewSize(this.siblingCell, siblingNewSize + "px");
          }
        }
      }
    });
    __publicField$3(this, "onMouseUp", () => {
      const { horizontal, onResize, index, itemsRefs, minSize } = this.props;
      horizontal ? this.ref.style.height = "20px" : this.ref.style.width = "20px";
      if (horizontal && this.curTarget) {
        const cellWidth = getRefWidthAsNumber(this.curTarget);
        const siblingWidth = this.siblingCell && getRefWidthAsNumber(this.siblingCell);
        cellWidth < minSize && (this.curTarget.style.minWidth = cellWidth);
        siblingWidth && siblingWidth < minSize && (this.siblingCell.style.minWidth = siblingWidth);
      }
      if (this.curTarget && this.position && this.curSize) {
        horizontal ? onResize(itemsRefs) : onResize(index, this.getSize());
        this.curTarget = void 0;
        this.position = void 0;
        this.curSize = void 0;
      }
    });
    __publicField$3(this, "getResizerStyle", () => {
      const { horizontal, highlightResizer, index, size } = this.props;
      let style = {};
      if (highlightResizer === index) {
        horizontal ? style = { height: size, borderRight: RESIZER_STYLE } : style = { width: size, borderBottom: RESIZER_STYLE, zIndex: 3 };
      }
      return style;
    });
    __publicField$3(this, "setRef", (ref) => this.ref = ref);
  }
  componentDidMount() {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  }
  componentWillUnmount() {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  }
  render() {
    const resizerStyle = this.getResizerStyle();
    return (
      //eslint-disable-next-line
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            styles$3.resizer,
            this.props.highlightOnly && styles$3.highlightOnly,
            this.props.horizontal ? styles$3.horizonResizer : styles$3.verticalResizer
          ),
          style: resizerStyle,
          onMouseDown: this.onMouseDown,
          ref: this.setRef
        }
      )
    );
  }
}
Resizer.propTypes = {
  index: PropTypes.number.isRequired,
  size: PropTypes.number,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  horizontal: PropTypes.bool,
  minSize: PropTypes.number,
  onResizeStart: PropTypes.func,
  itemsRefs: PropTypes.any,
  setContainerSize: PropTypes.func,
  highlightOnly: PropTypes.bool,
  overflowWidth: PropTypes.number
};

var styles$2 = {"container":"Dy4w2","selected":"z2Drv","selectAll":"-eCXo"};

var __defProp$7 = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
class Columns extends PureComponent {
  render() {
    const {
      colNum,
      colDragProps,
      activeDrag,
      selectAll,
      size,
      onResize,
      highlightResizer,
      onResizeStart,
      columnsRefs,
      tableOverflowWidth
    } = this.props;
    return /* @__PURE__ */ React.createElement("tr", null, [...Array(colNum).fill(0)].map((row, i) => /* @__PURE__ */ React.createElement(
      "td",
      {
        key: `column${i}`,
        className: classNames(
          styles$2.container,
          selectAll && styles$2.selectAll,
          (activeDrag == null ? void 0 : activeDrag.includes(i)) && styles$2.selected
        )
      },
      /* @__PURE__ */ React.createElement(
        DragAndDropSection,
        __spreadProps$2(__spreadValues$6({}, colDragProps), {
          horizontal: true,
          index: i,
          activeDrag,
          selectAll,
          size
        })
      ),
      onResize && /* @__PURE__ */ React.createElement(
        Resizer,
        {
          onResize,
          highlightResizer,
          horizontal: true,
          minSize: CELL_MANUAL_MIN_WIDTH,
          index: i,
          size,
          onResizeStart,
          itemsRefs: columnsRefs,
          overflowWidth: tableOverflowWidth
        }
      )
    )));
  }
}
Columns.propTypes = {
  colDragProps: PropTypes.object,
  colNum: PropTypes.number.isRequired,
  activeDrag: PropTypes.array,
  selectAll: PropTypes.bool,
  size: PropTypes.number,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onResizeStart: PropTypes.func,
  columnsRefs: PropTypes.array,
  tableOverflowWidth: PropTypes.number
};

var __defProp$6 = Object.defineProperty;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let TableRenderer$1 = class TableRenderer extends PureComponent {
  constructor(props) {
    super(props);
    __publicField$2(this, "onResizeWindow", debounce(() => {
      this.setState({ windowWidth: window.innerWidth });
      const { table, tableRef } = this.props;
      tableRef.offsetWidth && this.columns.forEach((col, i) => {
        const width = table.getCellWidthAsPixel(
          tableRef.offsetWidth - 1,
          i,
          table.getColsMinWidth()
        );
        col && (col.style.width = width + "px");
      });
    }, 60));
    this.columns = [props.table.getColNum()];
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResizeWindow);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResizeWindow);
  }
  render() {
    var _a;
    const {
      children,
      tableRef,
      table,
      colDragProps,
      onResize,
      onResizeStart,
      highlightResizer,
      selected,
      selectAll,
      tableHeight,
      isEditMode,
      isEditingActive,
      tableOverflowWidth
    } = this.props;
    const range = selected && getRange(selected);
    const colsMinWidth = table.getColsMinWidth();
    this.columns = this.columns.filter((elem) => elem.parentElement);
    return /* @__PURE__ */ React.createElement("table", { className: styles$5.container }, /* @__PURE__ */ React.createElement("colgroup", null, table.getColsWidth().map((cellWidth, i) => /* @__PURE__ */ React.createElement(
      "col",
      {
        key: i,
        ref: (ref) => ref && (this.columns[i] = ref),
        style: {
          width: (tableRef == null ? void 0 : tableRef.offsetWidth) ? table.getCellWidthAsPixel(tableRef.offsetWidth - 1, i, colsMinWidth) : cellWidth,
          minWidth: (colsMinWidth == null ? void 0 : colsMinWidth[i]) || CELL_AUTO_MIN_WIDTH
        }
      }
    ))), /* @__PURE__ */ React.createElement("thead", null, isEditMode && /* @__PURE__ */ React.createElement(
      Columns,
      {
        colDragProps,
        colNum: table.getColNum(),
        onResize,
        onResizeStart,
        highlightResizer,
        activeDrag: isEditingActive ? [] : (_a = table.getSelectedCols(range)) == null ? void 0 : _a.map((i) => parseInt(i)),
        selectAll,
        size: tableHeight,
        tableWidth: tableRef == null ? void 0 : tableRef.offsetWidth,
        columnsRefs: this.columns,
        tableOverflowWidth
      }
    )), /* @__PURE__ */ React.createElement("tbody", null, children));
  }
};
TableRenderer$1.propTypes = {
  children: PropTypes.any,
  columns: PropTypes.any,
  table: PropTypes.any,
  tableRef: PropTypes.any,
  colDragProps: PropTypes.object,
  onResize: PropTypes.func,
  onResizeStart: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  selectAll: PropTypes.bool,
  tableHeight: PropTypes.number,
  isEditMode: PropTypes.bool,
  selected: PropTypes.object,
  isEditingActive: PropTypes.bool,
  tableOverflowWidth: PropTypes.number
};

var styles$1 = {"container":"WszPp","selectAllContainer":"KClri","rows":"K1zBW","rowContainer":"jMQB1"};

var styles = {"selectAll":"wfEEE","activeSelectAll":"Juo5i"};

const SelectTable = ({ isActive, onClick }) => (
  //eslint-disable-next-line
  /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.selectAll, isActive && styles.activeSelectAll),
      onClick,
      "data-hook": "selectAllTableCells"
    },
    /* @__PURE__ */ React.createElement(SelectTableIcon, null)
  )
);
SelectTable.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

var __defProp$5 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Rows extends PureComponent {
  constructor(props) {
    super(props);
    __publicField$1(this, "setContainerSize", (size, index) => this.rows[index].style.height = size);
    this.rows = [props.rowNum];
  }
  render() {
    const {
      rowDragProps,
      activeDrag,
      size,
      onResize,
      highlightResizer,
      onResizeStart,
      isEditMode,
      isSelectAllActive,
      onSelectAllClick,
      rowNum,
      rowsHeights,
      isAllCellsSelected,
      rowsRefs,
      rowsMaxContentHeight
    } = this.props;
    return /* @__PURE__ */ React.createElement("div", { style: { display: isEditMode ? "flex" : "none" }, className: styles$1.container }, /* @__PURE__ */ React.createElement("div", { className: styles$1.selectAllContainer }, /* @__PURE__ */ React.createElement(SelectTable, { isActive: isSelectAllActive, onClick: onSelectAllClick }), /* @__PURE__ */ React.createElement(Resizer, { index: -1, highlightResizer, size: size + 20, highlightOnly: true })), /* @__PURE__ */ React.createElement("div", { className: styles$1.rows }, [...Array(rowNum).fill(0)].map((row, index) => /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: (ref) => this.rows[index] = ref,
        key: index,
        className: styles$1.rowContainer,
        style: { height: rowsHeights[index] || ROW_DEFAULT_HEIGHT }
      },
      /* @__PURE__ */ React.createElement(
        DragAndDropSection,
        __spreadProps$1(__spreadValues$5({}, rowDragProps), {
          index,
          activeDrag,
          selectAll: isAllCellsSelected,
          size
        })
      ),
      /* @__PURE__ */ React.createElement(
        Resizer,
        {
          index,
          highlightResizer,
          onResize,
          size: size + 20,
          key: "resizer",
          onResizeStart,
          itemsRefs: rowsRefs,
          setContainerSize: this.setContainerSize,
          minSize: Math.max(ROW_DEFAULT_HEIGHT, rowsMaxContentHeight == null ? void 0 : rowsMaxContentHeight[index])
        }
      )
    ))));
  }
}
Rows.propTypes = {
  rowDragProps: PropTypes.object.isRequired,
  size: PropTypes.number,
  activeDrag: PropTypes.array,
  selectAll: PropTypes.bool,
  onResize: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onResizeStart: PropTypes.func,
  isEditMode: PropTypes.bool,
  isSelectAllActive: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  rowNum: PropTypes.number,
  rowsHeights: PropTypes.array,
  isAllCellsSelected: PropTypes.bool,
  rowsRefs: PropTypes.array,
  rowsMaxContentHeight: PropTypes.array
};

const TABLE_TYPE = "wix-rich-content-plugin-table";
({
  insert: `${Node_Type.TABLE}.insert`
});

var __defProp$4 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TableViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "cellCreator", (i, j) => ({
      key: `${i}-${j}`,
      component: this.renderCell(i, j),
      forceComponent: true,
      disableUpdatedFlag: true
    }));
    __publicField(this, "renderCell", (i, j) => {
      const { renderInnerRCE, innerRCV } = this.props;
      return renderInnerRCE ? renderInnerRCE(i, j) : innerRCV({ contentState: this.table.getCellContent(i, j), renderedIn: TABLE_TYPE });
    });
    __publicField(this, "createRow", (i, columnsNumber) => [...Array(columnsNumber).fill(0)].map((cell, j) => this.cellCreator(i, j)));
    __publicField(this, "sheetRenderer", (props) => {
      return /* @__PURE__ */ React.createElement(
        TableRenderer$1,
        __spreadProps(__spreadValues$4({}, props), {
          table: this.table,
          tableRef: this.tableViewerRef,
          colDragProps: this.props.colDragProps,
          onResize: this.props.onResize,
          onResizeStart: this.props.onResizeStart,
          highlightResizer: this.props.highlightResizer,
          selectAll: this.props.selectAll,
          tableHeight: this.props.tableHeight,
          selected: this.props.selected,
          isEditMode: this.props.isEditMode,
          isEditingActive: this.props.isEditingActive,
          tableOverflowWidth: this.props.tableOverflowWidth
        })
      );
    });
    __publicField(this, "rowRenderer", (props) => /* @__PURE__ */ React.createElement(
      RowRenderer,
      __spreadProps(__spreadValues$4({}, props), {
        getRowHeight: this.table.getRowHeight,
        setRowRef: this.props.setRowRef,
        rowsToUpdate: this.props.rowsToUpdate
      })
    ));
    __publicField(this, "setCellRef", (ref) => this.cellRef = ref);
    __publicField(this, "setTableViewerRef", (ref) => {
      this.tableViewerRef = ref;
      if (!this.state.isTableRefSet) {
        this.setState({ isTableRefSet: true });
      }
    });
    __publicField(this, "cellRenderer", (props) => {
      const {
        setEditorRef,
        toolbarRef,
        setEditingActive,
        tableWidth,
        isMobile,
        selected = {},
        disableSelectedStyle,
        t,
        selectCellContent
      } = this.props;
      return /* @__PURE__ */ React.createElement(
        Cell,
        __spreadProps(__spreadValues$4({}, props), {
          ref: this.setCellRef,
          table: this.table,
          setEditorRef,
          toolbarRef,
          selectedCells: selected,
          setEditingActive,
          tableWidth,
          isMobile,
          disableSelectedStyle,
          t,
          selectCellContent
        })
      );
    });
    __publicField(this, "valueRenderer", (cell) => cell.component);
    this.table = this.props.table || new TableDataUtil(props.componentData);
    this.state = {};
  }
  componentDidMount() {
    this.tableViewerRef.children[0].classList.add("has-custom-focus");
  }
  render() {
    const { onSelect, selected, isEditMode, setCellContent, onClear, onPaste } = this.props;
    const rowNum = this.table.getRowNum();
    const colNum = this.table.getColNum();
    const grid = [...Array(rowNum).fill(0)].map((row, i) => this.createRow(i, colNum));
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(isEditMode ? styles$5.editMode : styles$5.viewMode),
        ref: this.setTableViewerRef
      },
      /* @__PURE__ */ React.createElement(
        DataSheet,
        {
          data: grid,
          valueRenderer: this.valueRenderer,
          onSelect,
          selected: selected || {},
          cellRenderer: this.cellRenderer,
          rowRenderer: this.rowRenderer,
          sheetRenderer: this.sheetRenderer,
          onClear,
          getCellContent: this.table.getCellContent,
          setCellContent,
          onPaste
        }
      )
    );
  }
}
TableViewer.propTypes = {
  theme: PropTypes.object.isRequired,
  renderInnerRCE: PropTypes.func,
  innerRCV: PropTypes.func,
  table: PropTypes.object,
  onSelect: PropTypes.func,
  setRowRef: PropTypes.func,
  setEditorRef: PropTypes.func,
  toolbarRef: PropTypes.any,
  setEditingActive: PropTypes.func,
  columns: PropTypes.any,
  selected: PropTypes.object,
  componentData: PropTypes.object,
  tableWidth: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool,
  t: PropTypes.func,
  disableSelectedStyle: PropTypes.bool,
  colDragProps: PropTypes.object,
  onResize: PropTypes.func,
  onResizeStart: PropTypes.func,
  highlightResizer: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  selectAll: PropTypes.bool,
  tableHeight: PropTypes.number,
  isEditingActive: PropTypes.bool,
  setCellContent: PropTypes.func,
  onClear: PropTypes.func,
  onPaste: PropTypes.func,
  tableOverflowWidth: PropTypes.number,
  rowsToUpdate: PropTypes.array,
  selectCellContent: PropTypes.func
};
var TableViewer$1 = TableViewer;

const typeMapper = () => ({
  [TABLE_TYPE]: { component: TableViewer$1, withHorizontalScroll: true }
});

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getCellWidthAsPixel = (tableWidth, i, colsMinWidth, colsWidthRatio) => {
  const colsWidthSum = colsWidthRatio.reduce((acc, val) => acc + val, 0);
  let smallestCellIndex, smallestCellWidth, currCellWidth;
  colsWidthRatio.forEach((width, index) => {
    const cellWidth = tableWidth * (width / colsWidthSum);
    if (index === i) {
      currCellWidth = cellWidth;
    } else if (cellWidth < CELL_AUTO_MIN_WIDTH && (!smallestCellWidth || smallestCellWidth > cellWidth)) {
      smallestCellWidth = Math.max(colsMinWidth[index], cellWidth);
      smallestCellIndex = index;
    }
  });
  if (smallestCellWidth) {
    currCellWidth = Math.min(CELL_AUTO_MIN_WIDTH, smallestCellWidth) * (colsWidthRatio[i] / colsWidthRatio[smallestCellIndex]);
  }
  return Math.max(currCellWidth, colsMinWidth[i]);
};
const Table = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  const tableRef = useRef(null);
  const { dimensions: { colsMinWidth = [], colsWidthRatio = [] } = {} } = node.tableData || {};
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, withHorizontalScroll: true }, /* @__PURE__ */ React.createElement("div", { ref: tableRef, className: styles$5.viewMode }, /* @__PURE__ */ React.createElement("table", { className: styles$5.container, "data-hook": "TableComponent" }, /* @__PURE__ */ React.createElement("colgroup", null, colsWidthRatio.map((ratio, index) => {
    var _a;
    const minWidth = colsMinWidth[index] || CELL_AUTO_MIN_WIDTH;
    const style = {
      width: ((_a = tableRef == null ? void 0 : tableRef.current) == null ? void 0 : _a.offsetWidth) ? getCellWidthAsPixel(
        tableRef.current.offsetWidth,
        index,
        colsMinWidth,
        colsWidthRatio
      ) : ratio || 0,
      minWidth
    };
    return /* @__PURE__ */ React.createElement("col", { key: index, style });
  })), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes }))))));
};
const TableRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$2(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Table, __spreadValues$3({ key: node.id, node }, props));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TableRow = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b, _c;
  const { parentNode } = useContext(RicosNodeContext);
  const style = { height: ((_c = (_b = (_a = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _a.dimensions) == null ? void 0 : _b.rowsHeight) == null ? void 0 : _c[nodeIndex]) || "auto" };
  return /* @__PURE__ */ React.createElement("tr", { style }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes })));
};
const TableRowRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$1(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(TableRow, __spreadValues$2({ key: node.id, node }, props));
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TableCell = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b;
  const { parentNode, parentIndex } = useContext(RicosNodeContext);
  const { borderColors, cellStyle } = (node == null ? void 0 : node.tableCellData) || {};
  const isHeaderCell = parentIndex === 0 && ((_a = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _a.rowHeader) || nodeIndex === 0 && ((_b = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _b.columnHeader);
  const Tag = isHeaderCell ? "th" : "td";
  const style = {};
  (cellStyle == null ? void 0 : cellStyle.backgroundColor) && (style.backgroundColor = cellStyle.backgroundColor);
  (cellStyle == null ? void 0 : cellStyle.verticalAlignment) && (style.verticalAlign = cellStyle.verticalAlignment.toLowerCase());
  return /* @__PURE__ */ React.createElement(
    Tag,
    {
      "data-hook": "table-plugin-cell",
      className: classNames(styles$7.cell, isHeaderCell && styles$7.header),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: classNames(styles$7.editor, styles$7.view) }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes, isRoot: true }))),
    CellBorders({ borders: borderColors })
  );
};
const TableCellRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(TableCell, __spreadValues$1({ key: node.id, node }, props));
};

const nodeViewRenderers = {
  [Node_Type$1.TABLE]: TableRenderer,
  [Node_Type$1.TABLE_ROW]: TableRowRenderer,
  [Node_Type$1.TABLE_CELL]: TableCellRenderer
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginTable = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: TABLE_TYPE,
    typeMapper,
    nodeViewRenderers,
    // decorator: (theme, config) => ...
    theme
  };
};

export { TABLE_TYPE, pluginTable, typeMapper as tableTypeMapper };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-table/dist/es/styles.viewer.min.global.css'